export default "__VITE_ASSET__Dwsz4gU6__"